import { PanelRightIcon } from 'lucide-react';
import { OverflowMenu, type OverflowItem } from '@/components/ui/menu';
import type { ActionView } from './action-confirmation';
import type { useActionConfirmation } from './use-action-confirmation';

type State = ReturnType<typeof useActionConfirmation>;
type RowMoreProps = {
  state: Pick<State, 'workspace' | 'origin' | 'surfaceCopy'>;
  action: Pick<ActionView, 'id'>;
};

/**
 * A small pending row shows both answers to its consent (Reject, Approve). Only
 * secondary, read-only choices live behind ⋯: Details opens this request's step
 * in the Activity view. Nothing here decides or approves.
 */
export function rowMoreItems({ state, action }: RowMoreProps): OverflowItem[] {
  const { workspace, origin, surfaceCopy } = state;
  if (!workspace) return [];
  return [
    {
      key: 'details',
      label: surfaceCopy.details,
      icon: <PanelRightIcon aria-hidden="true" />,
      onSelect: () =>
        workspace.openCanvas(
          origin
            ? { kind: 'activity', id: origin.messageId, tab: 'steps', step: origin.toolCallId }
            : { kind: 'action', id: action.id, tab: 'details' },
        ),
    },
  ];
}

export function ActionRowMore(props: RowMoreProps & { label: string }) {
  return <OverflowMenu label={props.label} items={rowMoreItems(props)} />;
}
